import { mutingList } from './mutingList';
import AlertsBanner from '../overview/alertsBanner';
import { react2angular } from 'react2angular';

angular
    .module('signalview.alertMuting', ['sfx.data'])
    .component('mutingList', mutingList)
    .component('mutingBanner', react2angular(AlertsBanner, null, ['currentUser']));
